import comp from "./InstructionAndToolsController";
export default comp;
